import tent from './tent.png';

export const TentSprite = (
  <image href={tent} />
);

export const TentFlapSprite = (
  <>
    <path
      fill="#f9b233"
      d="M0 128.91V59.82A59.89 59.89 0 0159.82 0H61a59.89 59.89 0 0159.82 59.82v69.09z"
    />
    <path
      fill="#1d1d1b"
      d="M118.94 127H1.88V59.82a57.94 57.94 0 0158-57.94H61a57.94 57.94 0 0157.94 57.94z"
    />
    <path
      fill="#f9b233"
      d="M99.72 127H1.88V59.82a57.87 57.87 0 0127.1-49 58.74 58.74 0 016.67-3.62 13.87 13.87 0 0117.76 5.91 16.09 16.09 0 01.94 2c.41 1.07.8 2.15 1.22 3.22l1.13 2.87c.43 1.15.88 2.28 1.35 3.41 5.49 13.85 11.45 27.44 17.36 41.02 8.57 19.67 17 39.26 23.67 59.49.23.65.43 1.28.64 1.88z"
    />
    <path
      fill="#235d85"
      d="M99.1 125.14H3.76V59.82A56 56 0 0136.42 8.88a11.63 11.63 0 014.84-1.06c5 0 12.52 5.72 14.31 10.48.36 1 .73 1.92 1.13 2.87.43 1.15.88 2.28 1.35 3.41 5.57 13.69 12 26.49 17.86 39.86 8.77 20.12 17.55 39.93 23.19 60.7z"
    />
    <path
      fill="#1d1d1b"
      d="M99.72 127H88v-1.89A99.87 99.87 0 0085.49 108a222.64 222.64 0 00-13-41.14 164.52 164.52 0 00-8.86-17.47C55.19 35 44.08 21.87 30.63 12c-.54-.41-1.09-.81-1.65-1.18a58.74 58.74 0 016.67-3.62 13.87 13.87 0 0117.76 5.91 16.09 16.09 0 01.94 2c.41 1.07.8 2.15 1.22 3.22l1.13 2.87c.43 1.15.88 2.28 1.35 3.41 5.57 13.69 12 26.49 17.86 39.86 8.77 20.12 17.55 39.93 23.19 60.7.21.6.41 1.23.62 1.83z"
      opacity="0.2"
    />
  </>
);
